import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../config";

function AddChristian() {
  // Form state
  const [formData, setFormData] = useState({
    full_name: "",
    national_id: "",
    phone_number: "",
    email: "",
    sex: "",
    date_of_birth: "",
    baptized: "",
    date_of_baptism: "",
    parish_of_baptism: "",
    godparent_name: "",
    marital_status: "",
    spouse_name: "",
    church_wedding: "",
    church_wedding_date: "",
    church_wedding_parish: "",
    civil_wedding: "",
    civil_wedding_date: "",
    widowed: "",
    death_date: "",
    widowed_spouse_name: "",
    divorced: "",
    divorce_date: "",
    divorced_spouse_name: "",
    employed: "",
    job_description: "",
    district: "",
    sector: "",
    cell: "",
    village: "",
    isibo: "",
    church_roles: [],
    choir_member: "",
    choir_group: "",
    has_children_under_12: "",
    num_children_under_12: 0,
    num_children_in_kicukiro: 0,
    num_children_outside_kicukiro: 0,
    spouse_prays_in_emrl: "",
    registered_phone_number: "",
    comments: "",
    status: "Active",
    studied: "",
    school: "",
    gusoma: "",
    education_level: "",
    field_of_study: "",
    professional_training: ""
  });

  const [loading, setLoading] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [activeSection, setActiveSection] = useState("personal");

  // Toggle visibility states
  const [showBaptismFields, setShowBaptismFields] = useState(false);
  const [showEducationFields, setShowEducationFields] = useState(false);
  const [showMarriedFields, setShowMarriedFields] = useState(false);
  const [showWidowedFields, setShowWidowedFields] = useState(false);
  const [showDivorcedFields, setShowDivorcedFields] = useState(false);
  const [showChildrenFields, setShowChildrenFields] = useState(false);
  const [showJobFields, setShowJobFields] = useState(false);
  const [showChoirGroup, setShowChoirGroup] = useState(false);

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Section navigation for mobile
  const sections = [
    { id: "personal", name: "Personal", icon: "👤" },
    { id: "baptism", name: "Baptism", icon: "✝️" },
    { id: "marital", name: "Marital", icon: "❤️" },
    { id: "education", name: "Education", icon: "📚" },
    { id: "employment", name: "Employment", icon: "💼" },
    { id: "address", name: "Address", icon: "🏠" },
    { id: "church", name: "Church", icon: "⛪" },
    { id: "children", name: "Children", icon: "👶" }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setActiveSection(sectionId);
    }
  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      if (name === "church_roles") {
        let updatedRoles = [...formData.church_roles];
        if (checked) {
          updatedRoles.push(value);
        } else {
          updatedRoles = updatedRoles.filter(role => role !== value);
        }
        setFormData(prev => ({ ...prev, church_roles: updatedRoles }));
        
        if (value === "Umuririmbyi") {
          setShowChoirGroup(checked);
        }
      }
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  // Handle radio button changes with special logic
  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    switch (name) {
      case "baptized":
        setShowBaptismFields(value === "Yego");
        break;
      case "studied":
        setShowEducationFields(value === "Yego");
        break;
      case "has_children_under_12":
        setShowChildrenFields(value === "Yes");
        break;
      case "employed":
        setShowJobFields(value === "Yego");
        break;
      case "marital_status":
        setShowMarriedFields(value === "Married");
        setShowWidowedFields(value === "Widowed");
        setShowDivorcedFields(value === "Divorced");
        break;
      default:
        break;
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const dataToSend = {
      ...formData,
      church_roles: formData.church_roles.join(', ')
    };
    try {
      const response = await axios.post(`${API_BASE_URL}/christian/register`, dataToSend);
      setModalMessage("Umwirondoro wawe woherejwe neza. Turagushimiye!");
      setShowModal(true);
      // Reset form
      setFormData({
        full_name: "",
        national_id: "",
        phone_number: "",
        email: "",
        sex: "",
        date_of_birth: "",
        baptized: "",
        date_of_baptism: "",
        parish_of_baptism: "",
        godparent_name: "",
        marital_status: "",
        spouse_name: "",
        church_wedding: "",
        church_wedding_date: "",
        church_wedding_parish: "",
        civil_wedding: "",
        civil_wedding_date: "",
        widowed: "",
        death_date: "",
        widowed_spouse_name: "",
        divorced: "",
        divorce_date: "",
        divorced_spouse_name: "",
        employed: "",
        job_description: "",
        district: "",
        sector: "",
        cell: "",
        village: "",
        isibo: "",
        church_roles: [],
        choir_member: "",
        choir_group: "",
        has_children_under_12: "",
        num_children_under_12: 0,
        num_children_in_kicukiro: 0,
        num_children_outside_kicukiro: 0,
        spouse_prays_in_emrl: "",
        registered_phone_number: "",
        comments: "",
        status: "Active",
        studied: "",
        school: "",
        gusoma: "",
        education_level: "",
        field_of_study: "",
        professional_training: ""
      });
      setShowBaptismFields(false);
      setShowEducationFields(false);
      setShowMarriedFields(false);
      setShowWidowedFields(false);
      setShowDivorcedFields(false);
      setShowChildrenFields(false);
      setShowJobFields(false);
      setShowChoirGroup(false);
    } catch (error) {
      setModalMessage("Ntabwo mwujuje neza ibisabwa, mwongere musubiremo");
      setShowModal(true);
      console.error("Error registering Christian:", error);
    } finally {
      setLoading(false);
    }
  };

  // Close modal
  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className="content px-3 sm:px-5 py-4 sm:py-6">
      {/* Mobile Section Navigation */}
      {isMobile && (
        <div className="sticky top-0 z-10 bg-white shadow-md rounded-lg mb-4 p-2 overflow-x-auto">
          <div className="flex space-x-2 min-w-max">
            {sections.map(section => (
              <button
                key={section.id}
                onClick={() => scrollToSection(section.id)}
                className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all whitespace-nowrap ${
                  activeSection === section.id
                    ? 'bg-[#164e63] text-white'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {section.icon} {section.name}
              </button>
            ))}
          </div>
        </div>
      )}

      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-xl shadow-lg md:mt-12  overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-[#164e63] to-[#1e6f8a] p-4 sm:p-6 text-center">
            <h1 className="text-xl sm:text-2xl font-bold text-white">Christian Registration Form</h1>
            <p className="text-xs sm:text-sm text-blue-100 mt-1">Iyi fomu uzayuzuza maze ukohereze</p>
          </div>

          <form onSubmit={handleSubmit} className="p-4 sm:p-6 space-y-6">
            {/* Personal Information Section */}
            <div id="personal" className="scroll-mt-20">
              <div className="bg-gradient-to-r from-[#164e63] to-[#1e6f8a] rounded-t-lg p-3 mb-4">
                <h2 className="text-white font-semibold text-base sm:text-lg">Personal Information</h2>
              </div>
              <div className="bg-white rounded-b-lg p-3 sm:p-5">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* Full Name */}
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Amazina Yombi (Full names): <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="full_name"
                      value={formData.full_name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* National ID */}
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Nimero y'irangamuntu (National ID):
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="national_id"
                      value={formData.national_id}
                      onChange={handleChange}
                      pattern="\d{16}"
                      title="Nimero y'irangamuntu igomba kuba imibare 16"
                      maxLength="16"
                    />
                  </div>

                  {/* Phone Number */}
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Nimero ya Telephone (Phone Number): <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="phone_number"
                      value={formData.phone_number}
                      onChange={handleChange}
                      pattern="^(\+2507[2389]\d{7}|07[2389]\d{7})$"
                      title="Andika nimero ya telephone yuzuye, e.g., 07889177.., +2507889177.."
                      required
                    />
                  </div>

                  {/* Registered Phone Number */}
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Iyi nimero ya telephone ikubaruyeho?: <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-wrap gap-4">
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="registered_phone_number"
                          value="Yego"
                          checked={formData.registered_phone_number === "Yego"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                          required
                        />
                        <span className="ml-2 text-sm">Yego</span>
                      </label>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="registered_phone_number"
                          value="Oya"
                          checked={formData.registered_phone_number === "Oya"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                          required
                        />
                        <span className="ml-2 text-sm">Oya</span>
                      </label>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Email:
                    </label>
                    <input
                      type="email"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Sex */}
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Igitsina (Sex): <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-wrap gap-4">
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="sex"
                          value="Male"
                          checked={formData.sex === "Male"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                          required
                        />
                        <span className="ml-2 text-sm">Gabo</span>
                      </label>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="sex"
                          value="Female"
                          checked={formData.sex === "Female"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                          required
                        />
                        <span className="ml-2 text-sm">Gore</span>
                      </label>
                    </div>
                  </div>

                  {/* Date of Birth */}
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Italiki y'amavuko (Date of Birth): <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="date_of_birth"
                      value={formData.date_of_birth}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Baptized */}
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Warabatijwe (Baptized): <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-wrap gap-4">
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="baptized"
                          value="Yego"
                          checked={formData.baptized === "Yego"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                          required
                        />
                        <span className="ml-2 text-sm">Yego</span>
                      </label>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="baptized"
                          value="Oya"
                          checked={formData.baptized === "Oya"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                          required
                        />
                        <span className="ml-2 text-sm">Oya</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Baptism Fields (shown conditionally) */}
            {showBaptismFields && (
              <div id="baptism" className="scroll-mt-20">
                <div className="bg-gradient-to-r from-[#164e63] to-[#1e6f8a] rounded-t-lg p-3 mb-4">
                  <h2 className="text-white font-semibold text-base sm:text-lg">Baptism Information</h2>
                </div>
                <div className="bg-blue-50 rounded-b-lg p-4 space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className="space-y-1">
                      <label className="block text-xs sm:text-sm font-medium text-gray-700">
                        Italiki yo kubatizwa (Date of Baptism):
                      </label>
                      <input
                        type="date"
                        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                        name="date_of_baptism"
                        value={formData.date_of_baptism}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="space-y-1">
                      <label className="block text-xs sm:text-sm font-medium text-gray-700">
                        Itorero wabatirijwemo (Church of Baptism):
                      </label>
                      <input
                        type="text"
                        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                        name="parish_of_baptism"
                        value={formData.parish_of_baptism}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="space-y-1">
                      <label className="block text-xs sm:text-sm font-medium text-gray-700">
                        Amazina y'umubyeyi wa batisimu (Godparent Name):
                      </label>
                      <input
                        type="text"
                        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                        name="godparent_name"
                        value={formData.godparent_name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Marital Status Section */}
            <div id="marital" className="scroll-mt-20">
              <div className="bg-gradient-to-r from-[#164e63] to-[#1e6f8a] rounded-t-lg p-3 mb-4">
                <h2 className="text-white font-semibold text-base sm:text-lg">Marital Status</h2>
              </div>
              <div className="bg-white rounded-b-lg p-3 sm:p-5">
                <div className="space-y-2">
                  <label className="block text-xs sm:text-sm font-medium text-gray-700">
                    Irangamimerere (Marital Status): <span className="text-red-500">*</span>
                  </label>
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="marital_status"
                        value="Single"
                        checked={formData.marital_status === "Single"}
                        onChange={handleRadioChange}
                        className="text-[#164e63] focus:ring-[#164e63]"
                        required
                      />
                      <span className="ml-2 text-sm">Ingaragu</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="marital_status"
                        value="Married"
                        checked={formData.marital_status === "Married"}
                        onChange={handleRadioChange}
                        className="text-[#164e63] focus:ring-[#164e63]"
                        required
                      />
                      <span className="ml-2 text-sm">Uwubatse</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="marital_status"
                        value="Widowed"
                        checked={formData.marital_status === "Widowed"}
                        onChange={handleRadioChange}
                        className="text-[#164e63] focus:ring-[#164e63]"
                        required
                      />
                      <span className="ml-2 text-sm">Uwapfakaye</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="marital_status"
                        value="Divorced"
                        checked={formData.marital_status === "Divorced"}
                        onChange={handleRadioChange}
                        className="text-[#164e63] focus:ring-[#164e63]"
                        required
                      />
                      <span className="ml-2 text-sm">Uwatandukanye</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {/* Married Fields (shown conditionally) */}
            {showMarriedFields && (
              <div className="bg-blue-50 rounded-lg p-4 space-y-4">
                <h3 className="font-semibold text-[#164e63] text-base">Marriage Information</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Amazina yuwo mwashakanye (Spouse's Name):
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="spouse_name"
                      value={formData.spouse_name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Asengera EMRL kicukiro?:
                    </label>
                    <div className="flex flex-wrap gap-4">
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="spouse_prays_in_emrl"
                          value="Yes"
                          checked={formData.spouse_prays_in_emrl === "Yes"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                        />
                        <span className="ml-2 text-sm">Yego</span>
                      </label>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="spouse_prays_in_emrl"
                          value="No"
                          checked={formData.spouse_prays_in_emrl === "No"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                        />
                        <span className="ml-2 text-sm">Oya</span>
                      </label>
                    </div>
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Mwarasezeranye mu itorero?:
                    </label>
                    <div className="flex flex-wrap gap-4">
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="church_wedding"
                          value="Yes"
                          checked={formData.church_wedding === "Yes"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                        />
                        <span className="ml-2 text-sm">Yego</span>
                      </label>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="church_wedding"
                          value="No"
                          checked={formData.church_wedding === "No"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                        />
                        <span className="ml-2 text-sm">Oya</span>
                      </label>
                    </div>
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Itariki mwasezeraniyeho mu itorero:
                    </label>
                    <input
                      type="date"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="church_wedding_date"
                      value={formData.church_wedding_date}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Itorero mwasezeraniyemo:
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="church_wedding_parish"
                      value={formData.church_wedding_parish}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Mwarasezeranye mu biro?:
                    </label>
                    <div className="flex flex-wrap gap-4">
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="civil_wedding"
                          value="Yes"
                          checked={formData.civil_wedding === "Yes"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                        />
                        <span className="ml-2 text-sm">Yego</span>
                      </label>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="civil_wedding"
                          value="No"
                          checked={formData.civil_wedding === "No"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                        />
                        <span className="ml-2 text-sm">Oya</span>
                      </label>
                    </div>
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Itariki mwasezeraniyeho mu biro:
                    </label>
                    <input
                      type="date"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="civil_wedding_date"
                      value={formData.civil_wedding_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Widowed Fields (shown conditionally) */}
            {showWidowedFields && (
              <div className="bg-blue-50 rounded-lg p-4 space-y-4">
                <h3 className="font-semibold text-[#164e63] text-base">Widow Information</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Uwapfakaye:
                    </label>
                    <select
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="widowed"
                      value={formData.widowed}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                    </select>
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Amatariki y'Urupfu (Umupfakazi):
                    </label>
                    <input
                      type="date"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="death_date"
                      value={formData.death_date}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Amazina y'Uwo Mwashakanye (Uwapfakaye):
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="widowed_spouse_name"
                      value={formData.widowed_spouse_name}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Divorced Fields (shown conditionally) */}
            {showDivorcedFields && (
              <div className="bg-blue-50 rounded-lg p-4 space-y-4">
                <h3 className="font-semibold text-[#164e63] text-base">Divorce Information</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Uwatandukanye:
                    </label>
                    <select
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="divorced"
                      value={formData.divorced}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                    </select>
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Itariki yo Gutandukana (Uwatandukanye):
                    </label>
                    <input
                      type="date"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="divorce_date"
                      value={formData.divorce_date}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Amazina y'Uwo Mwatandukanye (Uwatandukanye):
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="divorced_spouse_name"
                      value={formData.divorced_spouse_name}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Education Section */}
            <div id="education" className="scroll-mt-20">
              <div className="bg-gradient-to-r from-[#164e63] to-[#1e6f8a] rounded-t-lg p-3 mb-4">
                <h2 className="text-white font-semibold text-base sm:text-lg">Education</h2>
              </div>
              <div className="bg-white rounded-b-lg p-3 sm:p-5">
                <div className="space-y-4">
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Warize (have you studied)? <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-wrap gap-4">
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="studied"
                          value="Yego"
                          checked={formData.studied === "Yego"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                          required
                        />
                        <span className="ml-2 text-sm">Yego</span>
                      </label>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="studied"
                          value="Oya"
                          checked={formData.studied === "Oya"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                          required
                        />
                        <span className="ml-2 text-sm">Oya</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Education Fields (shown conditionally) */}
            {showEducationFields && (
              <div className="bg-blue-50 rounded-lg p-4 space-y-4">
                <h3 className="font-semibold text-[#164e63] text-base">Education Information</h3>
                <div className="grid grid-cols-1 gap-4">
                  <div className="space-y-2">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Amashuri wize (Education Level):
                    </label>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="education_level"
                          value="Amashuri abanza"
                          checked={formData.education_level === "Amashuri abanza"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                        />
                        <span className="ml-2 text-sm">Amashuri abanza</span>
                      </label>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="education_level"
                          value="Amashuri yisumbuye"
                          checked={formData.education_level === "Amashuri yisumbuye"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                        />
                        <span className="ml-2 text-sm">Amashuri yisumbuye</span>
                      </label>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="education_level"
                          value="Ikiciro cya 1 cya Kaminuza (A1)"
                          checked={formData.education_level === "Ikiciro cya 1 cya Kaminuza (A1)"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                        />
                        <span className="ml-2 text-sm">Ikiciro cya 1 cya Kaminuza (A1)</span>
                      </label>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="education_level"
                          value="Ikiciro cya 2 cya Kaminuza (A0)"
                          checked={formData.education_level === "Ikiciro cya 2 cya Kaminuza (A0)"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                        />
                        <span className="ml-2 text-sm">Ikiciro cya 2 cya Kaminuza (A0)</span>
                      </label>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="education_level"
                          value="Ikiciro cya 3 cya Kaminuza (Masters)"
                          checked={formData.education_level === "Ikiciro cya 3 cya Kaminuza (Masters)"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                        />
                        <span className="ml-2 text-sm">Ikiciro cya 3 cya Kaminuza (Masters)</span>
                      </label>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="education_level"
                          value="PhD"
                          checked={formData.education_level === "PhD"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                        />
                        <span className="ml-2 text-sm">PhD</span>
                      </label>
                    </div>
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Ibyo wize (Field of Study):
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="field_of_study"
                      value={formData.field_of_study}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Wize imyuga? vuga umwuga wize (Professional trainings):
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="professional_training"
                      value={formData.professional_training}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Employment Section */}
            <div id="employment" className="scroll-mt-20">
              <div className="bg-gradient-to-r from-[#164e63] to-[#1e6f8a] rounded-t-lg p-3 mb-4">
                <h2 className="text-white font-semibold text-base sm:text-lg">Employment</h2>
              </div>
              <div className="bg-white rounded-b-lg p-3 sm:p-5">
                <div className="space-y-4">
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Urakora?: <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-wrap gap-4">
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="employed"
                          value="Yego"
                          checked={formData.employed === "Yego"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                          required
                        />
                        <span className="ml-2 text-sm">Yego</span>
                      </label>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="employed"
                          value="Oya"
                          checked={formData.employed === "Oya"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                          required
                        />
                        <span className="ml-2 text-sm">Oya</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Job Description (shown conditionally) */}
            {showJobFields && (
              <div className="bg-blue-50 rounded-lg p-4 space-y-4">
                <h3 className="font-semibold text-[#164e63] text-base">Employment Information</h3>
                <div className="space-y-2">
                  <label className="block text-xs sm:text-sm font-medium text-gray-700">
                    Imirimo (Job Description):
                  </label>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="job_description"
                        value="Ndikorera"
                        checked={formData.job_description === "Ndikorera"}
                        onChange={handleRadioChange}
                        className="text-[#164e63] focus:ring-[#164e63]"
                      />
                      <span className="ml-2 text-sm">Ndikorera</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="job_description"
                        value="Nkorera Leta"
                        checked={formData.job_description === "Nkorera Leta"}
                        onChange={handleRadioChange}
                        className="text-[#164e63] focus:ring-[#164e63]"
                      />
                      <span className="ml-2 text-sm">Nkorera Leta</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="job_description"
                        value="Nkorera Abandi"
                        checked={formData.job_description === "Nkorera Abandi"}
                        onChange={handleRadioChange}
                        className="text-[#164e63] focus:ring-[#164e63]"
                      />
                      <span className="ml-2 text-sm">Nkorera Abandi</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="job_description"
                        value="Ibiraka"
                        checked={formData.job_description === "Ibiraka"}
                        onChange={handleRadioChange}
                        className="text-[#164e63] focus:ring-[#164e63]"
                      />
                      <span className="ml-2 text-sm">Ibiraka</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="job_description"
                        value="Imiryango Itegamiye kuri Leta"
                        checked={formData.job_description === "Imiryango Itegamiye kuri Leta"}
                        onChange={handleRadioChange}
                        className="text-[#164e63] focus:ring-[#164e63]"
                      />
                      <span className="ml-2 text-sm">Imiryango Itegamiye kuri Leta</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="job_description"
                        value="Umukozi wa EMLR Kicukiro (Uhembwa)"
                        checked={formData.job_description === "Umukozi wa EMLR Kicukiro (Uhembwa)"}
                        onChange={handleRadioChange}
                        className="text-[#164e63] focus:ring-[#164e63]"
                      />
                      <span className="ml-2 text-sm">Umukozi wa EMLR Kicukiro (Uhembwa)</span>
                    </label>
                  </div>
                </div>
              </div>
            )}

            {/* Address Information Section */}
            <div id="address" className="scroll-mt-20">
              <div className="bg-gradient-to-r from-[#164e63] to-[#1e6f8a] rounded-t-lg p-3 mb-4">
                <h2 className="text-white font-semibold text-base sm:text-lg">Address Information</h2>
              </div>
              <div className="bg-white rounded-b-lg p-3 sm:p-5">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Aho utuye Akarere (District): <span className="text-red-500">*</span>
                    </label>
                    <select
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="district"
                      value={formData.district}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Hitamo Akarere</option>
                      <option value="Gasabo">Gasabo</option>
                      <option value="Kicukiro">Kicukiro</option>
                      <option value="Nyarugenge">Nyarugenge</option>
                    </select>
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Umurenge (Sector): <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="sector"
                      value={formData.sector}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Akagari (Cell): <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="cell"
                      value={formData.cell}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Umudugudu (Village): <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="village"
                      value={formData.village}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Isibo:
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="isibo"
                      value={formData.isibo}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Church Information Section */}
            <div id="church" className="scroll-mt-20">
              <div className="bg-gradient-to-r from-[#164e63] to-[#1e6f8a] rounded-t-lg p-3 mb-4">
                <h2 className="text-white font-semibold text-base sm:text-lg">Church Information</h2>
              </div>
              <div className="bg-white rounded-b-lg p-3 sm:p-5">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Ishuli ubarizwamo: <span className="text-red-500">*</span>
                    </label>
                    <select
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="school"
                      value={formData.school}
                      onChange={handleChange}
                      required
                    >
                      <option value="Kicukiro">Kicukiro</option>
                      <option value="Kanombe">Kanombe</option>
                      <option value="Gahanga">Gahanga</option>
                    </select>
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Itsinda ubarizwamo: <span className="text-red-500">*</span>
                    </label>
                    <select
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="choir_member"
                      value={formData.choir_member}
                      onChange={handleChange}
                      required
                    >
                          <option value="Kicukiro">Kicukiro</option>
                    <option value="Kagarama-Niboye">Kagarama-Niboye</option>
                    <option value="Kabeza-Kanombe">Kabeza-Kanombe</option>
                    <option value="Nyarugenge">Nyarugenge</option>
                    <option value="Kimironko">Kimironko</option>
                    <option value="Nyabisindu">Nyabisindu</option>
                    <option value="Gatenga">Gatenga</option>
                    <option value="Kagugu-Batsinda">Kagugu-Batsinda</option>
                    <option value="Kimisagara">Kimisagara</option>
                    <option value="Gatsata-Bweramvura">Gatsata-Bweramvura</option>
                    <option value="Gikondo-Kigarama">Gikondo-Kigarama</option>
                    <option value="Remera">Remera</option>
                    <option value="Kagina">Kagina</option>
                    <option value="Karembure">Karembure</option>
                    <option value="Rwabutenge">Rwabutenge</option>
                    <option value="Nyakabungo">Nyakabungo</option>
                    <option value="Kabuga">Kabuga</option>
                    <option value="Ntatsinda ubarizwamo">Ntatsinda ubarizwamo</option>
                    <option value="Rwanko">Rwanko</option>
                    <option value="Nyirakanamba">Nyirakanamba</option>
                    <option value="Nyabyunyu">Nyabyunyu</option>
                    <option value="Antenne">Antenne</option>
                    <option value="Gatovu">Gatovu</option>
                    <option value="Kiyanja">Kiyanja</option>
                    <option value="Kagasa">Kagasa</option>
                    </select>
                  </div>
                </div>

                <div className="mt-4 space-y-2">
                  <label className="block text-xs sm:text-sm font-medium text-gray-700">
                    Imirimo mu Itorero (Church Ministry Activities): <span className="text-red-500">*</span>
                  </label>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        name="church_roles"
                        value="Umujyanama"
                        checked={formData.church_roles.includes("Umujyanama")}
                        onChange={handleChange}
                        className="text-[#164e63] focus:ring-[#164e63] rounded"
                      />
                      <span className="ml-2 text-sm">Umujyanama</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        name="church_roles"
                        value="Umuririmbyi"
                        checked={formData.church_roles.includes("Umuririmbyi")}
                        onChange={handleChange}
                        className="text-[#164e63] focus:ring-[#164e63] rounded"
                      />
                      <span className="ml-2 text-sm">Umuririmbyi</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        name="church_roles"
                        value="Protocol"
                        checked={formData.church_roles.includes("Protocol")}
                        onChange={handleChange}
                        className="text-[#164e63] focus:ring-[#164e63] rounded"
                      />
                      <span className="ml-2 text-sm">Protocol</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        name="church_roles"
                        value="Technic"
                        checked={formData.church_roles.includes("Technic")}
                        onChange={handleChange}
                        className="text-[#164e63] focus:ring-[#164e63] rounded"
                      />
                      <span className="ml-2 text-sm">Technic</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        name="church_roles"
                        value="Umunyamasengesho"
                        checked={formData.church_roles.includes("Umunyamasengesho")}
                        onChange={handleChange}
                        className="text-[#164e63] focus:ring-[#164e63] rounded"
                      />
                      <span className="ml-2 text-sm">Umunyamasengesho</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        name="church_roles"
                        value="Umuvugabutumwa"
                        checked={formData.church_roles.includes("Umuvugabutumwa")}
                        onChange={handleChange}
                        className="text-[#164e63] focus:ring-[#164e63] rounded"
                      />
                      <span className="ml-2 text-sm">Umuvugabutumwa</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        name="church_roles"
                        value="Umuyobozi w'itsinda"
                        checked={formData.church_roles.includes("Umuyobozi w'itsinda")}
                        onChange={handleChange}
                        className="text-[#164e63] focus:ring-[#164e63] rounded"
                      />
                      <span className="ml-2 text-sm">Umuyobozi w'itsinda</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        name="church_roles"
                        value="Umupasitori (Pastor)"
                        checked={formData.church_roles.includes("Umupasitori (Pastor)")}
                        onChange={handleChange}
                        className="text-[#164e63] focus:ring-[#164e63] rounded"
                      />
                      <span className="ml-2 text-sm">Umupasitori (Pastor)</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        name="church_roles"
                        value="Umukirisitu usanzwe"
                        checked={formData.church_roles.includes("Umukirisitu usanzwe")}
                        onChange={handleChange}
                        className="text-[#164e63] focus:ring-[#164e63] rounded"
                      />
                      <span className="ml-2 text-sm">Umukirisitu usanzwe</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {/* Choir Group (shown conditionally) */}
            {showChoirGroup && (
              <div className="bg-blue-50 rounded-lg p-4 space-y-4">
                <label className="block text-xs sm:text-sm font-medium text-gray-700">
                  Niba Uririmba, Uririmba Murihe Itsinda?:
                </label>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="choir_group"
                      value="Narada"
                      checked={formData.choir_group === "Narada"}
                      onChange={handleRadioChange}
                      className="text-[#164e63] focus:ring-[#164e63]"
                    />
                    <span className="ml-2 text-sm">Narada</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="choir_group"
                      value="Byiringiro"
                      checked={formData.choir_group === "Byiringiro"}
                      onChange={handleRadioChange}
                      className="text-[#164e63] focus:ring-[#164e63]"
                    />
                    <span className="ml-2 text-sm">Byiringiro</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="choir_group"
                      value="Fruta Melody"
                      checked={formData.choir_group === "Fruta Melody"}
                      onChange={handleRadioChange}
                      className="text-[#164e63] focus:ring-[#164e63]"
                    />
                    <span className="ml-2 text-sm">Fruta Melody</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="choir_group"
                      value="Reverence"
                      checked={formData.choir_group === "Reverence"}
                      onChange={handleRadioChange}
                      className="text-[#164e63] focus:ring-[#164e63]"
                    />
                    <span className="ml-2 text-sm">Reverence</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="choir_group"
                      value="Maranata"
                      checked={formData.choir_group === "Maranata"}
                      onChange={handleRadioChange}
                      className="text-[#164e63] focus:ring-[#164e63]"
                    />
                    <span className="ml-2 text-sm">Maranata</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="choir_group"
                      value="Ebenezer"
                      checked={formData.choir_group === "Ebenezer"}
                      onChange={handleRadioChange}
                      className="text-[#164e63] focus:ring-[#164e63]"
                    />
                    <span className="ml-2 text-sm">Ebenezer</span>
                  </label>
                </div>
              </div>
            )}

            {/* Children Section */}
            <div id="children" className="scroll-mt-20">
              <div className="bg-gradient-to-r from-[#164e63] to-[#1e6f8a] rounded-t-lg p-3 mb-4">
                <h2 className="text-white font-semibold text-base sm:text-lg">Children</h2>
              </div>
              <div className="bg-white rounded-b-lg p-3 sm:p-5">
                <div className="space-y-4">
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Ufite abana bari munsi y'imyaka 12 (Do you have children)?: <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-wrap gap-4">
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="has_children_under_12"
                          value="Yes"
                          checked={formData.has_children_under_12 === "Yes"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                          required
                        />
                        <span className="ml-2 text-sm">Yego</span>
                      </label>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="has_children_under_12"
                          value="No"
                          checked={formData.has_children_under_12 === "No"}
                          onChange={handleRadioChange}
                          className="text-[#164e63] focus:ring-[#164e63]"
                          required
                        />
                        <span className="ml-2 text-sm">Oya</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Children Fields (shown conditionally) */}
            {showChildrenFields && (
              <div className="bg-blue-50 rounded-lg p-4 space-y-4">
                <h3 className="font-semibold text-[#164e63] text-base">Children Information</h3>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Ni bangahe?:
                    </label>
                    <input
                      type="number"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="num_children_under_12"
                      value={formData.num_children_under_12}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Abasengera EMRL Kicukiro nibangahe?:
                    </label>
                    <input
                      type="number"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="num_children_in_kicukiro"
                      value={formData.num_children_in_kicukiro}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-1">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      Abasengera ahandi nibangahe?:
                    </label>
                    <input
                      type="number"
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                      name="num_children_outside_kicukiro"
                      value={formData.num_children_outside_kicukiro}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Comments */}
            <div className="space-y-1">
              <label className="block text-sm font-medium text-gray-700">
                Andika Igitekerezo, inyunganizi, icyifuzo:
              </label>
              <textarea 
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#164e63] focus:border-[#164e63]"
                name="comments"
                rows="4"
                value={formData.comments}
                onChange={handleChange}
              />
            </div>

            {/* Agreement Checkbox */}
            <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg">
              <input
                type="checkbox"
                className="h-4 w-4 text-[#164e63] focus:ring-[#164e63] border-gray-300 rounded mt-0.5"
                id="agreement"
                required
              />
              <label htmlFor="agreement" className="text-xs sm:text-sm text-gray-700">
                <i>Ndemeza ko amakuru nujuje muri iyi ifishi ari ay'ukuri, kandi nemeranya n'uko ayo makuru azakoreshwa mu itorero ryanjye Eglise Méthodiste Libre au Rwanda.</i>
              </label>
            </div>

            {loading && (
              <div className="text-center py-4">
                <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-[#164e63]"></div>
                <p className="text-sm text-gray-600 mt-2">Submitting...</p>
              </div>
            )}

            <button 
              type="submit"  
              className="w-full bg-gradient-to-r from-[#164e63] to-[#1e6f8a] hover:from-[#123d4f] hover:to-[#164e63] text-white font-bold py-3 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#164e63] transition duration-150 ease-in-out disabled:opacity-50"
              disabled={loading}
            >
              {loading ? 'Submitting...' : 'Ohereza'}
            </button>
          </form>
        </div>
      </div>

      {/* Success Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 animate-fadeIn">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-medium text-gray-900">Submission Status</h3>
              <button 
                onClick={closeModal}
                className="text-gray-400 hover:text-gray-500 focus:outline-none"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="mt-2 text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
                <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <p className="text-sm text-gray-500">{modalMessage}</p>
            </div>
            <div className="mt-6">
              <button
                type="button"
                onClick={closeModal}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#164e63] hover:bg-[#123d4f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#164e63]"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out;
        }
      `}</style>
    </div>
  );
}

export default AddChristian;